import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';

export default{
    state:{
        genres:[]
    },
    getters,
    mutations,
    actions,
}


// WEBPACK FOOTER //
// ./src/modules/genres/store/index.js